<template>
  <v-menu
    v-model="navigation.contextMenuIsVisible"
    @update:model-value="navigation.contextMenuIsVisible == false ? navigation.contextMenuItem = null : null"
    @contextmenu.prevent="navigation.contextMenuIsVisible = false; navigation.contextMenuItem = null;"
    :activator="false"
    location-strategy="static"
    transition="scroll-y-transition"
    scrim="black"
    opacity="0.8"
    style="user-select: none; cursor: default;"
  >
    <v-list
      :style="`top: ${navigation.contextMenuY}px; left: ${navigation.contextMenuX}px;`"
      density="compact"
      style="position: absolute; width: 550px; height: auto; max-height: 400px; overflow-x: hidden; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;" 
    >
      <template v-if="navigation.contextMenuItem && navigation.contextMenuItem.type == 'CRMWhatsappProductFollowup'">
        <v-list-item
          @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del seguimiento de producto', 'o', navigation.contextMenuItem.CRMWhatsappProductFollowupID);"
          title="Copiar ID del seguimiento de producto"
          class="hoverableVListItem"
        >
          <template v-slot:prepend>
            <v-icon color="indigo">mdi-source-branch-sync</v-icon>
            <v-icon color="indigo" size="x-small">mdi-barcode</v-icon>
          </template>
        </v-list-item>
        <v-list-item
          @click="$root.dialogComponent.openCRMWhatsappProductFollowupDialog('select', null, navigation.contextMenuItem.CRMWhatsappProductFollowupID, null, null)"
          title="Ver seguimiento de producto"
          class="hoverableVListItem"
        >
          <template v-slot:prepend>
            <v-icon color="indigo">mdi-source-branch-sync</v-icon>
            <v-icon color="indigo" size="small">mdi-open-in-app</v-icon>
          </template>
        </v-list-item>
        <v-list-item
          @click="$root.dialogComponent.openCRMWhatsappProductFollowupDialog('update', null, navigation.contextMenuItem.CRMWhatsappProductFollowupID, null, (() => this.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView(true)))"
          title="Actualizar seguimiento de producto"
          class="hoverableVListItem"
        >
          <template v-slot:prepend>
            <v-icon color="indigo">mdi-source-branch-sync</v-icon>
            <v-icon color="indigo" size="small">mdi-pencil</v-icon>
          </template>
        </v-list-item>
        <v-list-item
          @click="$root.dialogComponent.openCRMWhatsappProductFollowupDialog('delete', null, navigation.contextMenuItem.CRMWhatsappProductFollowupID, null, (() => this.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView(true)))"
          title="Eliminar seguimiento de producto"
          class="hoverableVListItem"
        >
          <template v-slot:prepend>
            <v-icon color="indigo">mdi-source-branch-sync</v-icon>
            <v-icon color="indigo" size="small">mdi-delete</v-icon>
          </template>
        </v-list-item>
        <v-list-item
          @click="$root.dialogComponent.openSendCRMWhatsappMessageToCRMWhatsappContactDialog(navigation.contextMenuItem.CRMWhatsappContactID, false)"
          title="Iniciar conversación"
          class="hoverableVListItem"
        >
          <template v-slot:prepend>
            <v-icon color="indigo">mdi-chat-plus</v-icon>
          </template>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
  <div
    @contextmenu.prevent="null"
    style="height: 100vh; overflow-y: hidden; display: flex; flex-direction: column; user-select: none; cursor: default;"
  >
    <v-card color="primary" elevation="0" rounded="0" style="flex-shrink: 0; padding: 15px;">
      <div style="display: flex; align-items: center;">
        <v-icon color="indigo" size="large" style="margin-right: 10px;">mdi-source-branch-sync</v-icon>
        <h2>Seguimientos de producto</h2>
      </div>
    </v-card>
    <v-card elevation="0" rounded="0" color="indigo" style="flex-shrink: 0; height: 2px;"></v-card>
    <template v-if="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView || computed_CRMWhatsappProductFollowupCount == 0">
      <v-card elevation="0" rounded="0" style="flex: 1; min-height: 0; display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 15px; gap: 5px;">
        <template v-if="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView">
          <AppLoaderScreen
            :appLogoSize="'x-small'"
            :loadingText="'Cargando seguimientos de producto'"
            :dotsToAnimate="3"
          ></AppLoaderScreen>
        </template>
        <template v-else-if="navigation.noData">
          <v-icon color="tertiary">mdi-information</v-icon>
          <p style="color: #9e9e9e;">No se ha encontrado ningún seguimiento de producto con los filtros de búsqueda aplicados</p>
          <div class="twoColumnContainer">
            <p style="color: #9e9e9e;">Puedes limpiar los filtros de búsqueda presionando</p>
            <v-btn
              @click="input.CRMWhatsappProductFollowupCreationCRMAgentID.length = 0; input.CRMWhatsappProductFollowupSearchQuery = null; display.CRMWhatsappProductFollowup = null; navigation.noData = false; selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView(true)"
              color="secondary"
              density="compact"
              class="hoverableVButton"
            >
              <v-icon start size="large">mdi-backspace</v-icon>
              <p style="font-size: small;">LIMPIAR</p>
            </v-btn>
          </div>
        </template>
        <template v-else>
          <v-icon color="tertiary">mdi-information</v-icon>
          <div class="twoColumnContainer">
            <p style="color: #9e9e9e;">Selecciona uno o más criterios de búsqueda y presiona</p>
            <v-btn
              @click="selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView(false)"
              color="indigo"
              density="compact"
              class="hoverableVButton"
            >
              <v-icon start size="large">mdi-magnify</v-icon>
              <p style="font-size: small;">BUSCAR</p>
            </v-btn>
          </div>
        </template>
      </v-card>
    </template>
    <template v-else>
      <v-data-table
        :headers="computed_CRMWhatsappProductFollowupHeaders"
        :items="computed_CRMWhatsappProductFollowup"
        :hover="computed_CRMWhatsappProductFollowup.length > 1"
        :items-per-page="-1"
        fixed-header
        style="flex: 1; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;"
      >
        <template v-slot:headers="{ columns }">
          <tr>
            <template
              v-for="column in columns"
              :key="column.value"
            >
              <th>
                <v-card elevation="0" rounded="0" style="display: flex; align-items: center; white-space: nowrap; height: 58px; width: 100%; padding: 0px 25px;">
                  <template v-if="computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).index > 0">
                    <v-icon 
                      @click="updateTableHeaderIndex('CRMWhatsappProductFollowup', column.value, -1)"
                      color="tertiary"
                      size="x-small"
                      class="hoverableVIcon"
                      style="margin-right: 10px"
                    >
                      mdi-arrow-left-bold
                    </v-icon>
                  </template>
                  <v-icon color="indigo" style="margin-right: 5px;">{{ computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).icon }}</v-icon>
                  <template v-if="computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).visible">
                    <p style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).title }}</strong></p>
                  </template>
                  <v-icon 
                    @click="computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).visible = !computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).visible; updateTableVisibility('CRMWhatsappProductFollowup')"
                    color="tertiary"
                    size="x-small"
                    class="hoverableVIcon"
                  >
                    mdi-{{ computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).visible ? 'eye' : 'eye-off' }}
                  </v-icon>
                  <template v-if="computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).index < computed_CRMWhatsappProductFollowupHeaders.length - 1">
                    <v-icon
                      @click="updateTableHeaderIndex('CRMWhatsappProductFollowup', column.value, 1)"
                      color="tertiary"
                      size="x-small"
                      class="hoverableVIcon"
                      style="margin-left: 10px"
                    >
                      mdi-arrow-right-bold
                    </v-icon>
                  </template>
                </v-card>
                <v-card color="grey-lighten-2" elevation="0" rounded="0" style="height: 1px;"></v-card>
              </th>
            </template>
          </tr>
        </template>
        <template v-slot:item="row">
          <tr
            :class="getTableRowClass('CRMWhatsappProductFollowup', row.item)" 
            :style="(loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView || loader.pagination) ? 'pointer-events: none;' : null"
          >
            <template
              v-for="header in computed_CRMWhatsappProductFollowupHeaders"
              :key="header.value"
            >
              <td @contextmenu.prevent="navigation.contextMenuIsVisible = true; navigation.contextMenuItem = {'type': 'CRMWhatsappProductFollowup', ...row.item}; navigation.contextMenuX = $event.clientX; navigation.contextMenuY = $event.clientY;">
                <template v-if="header.value == 'CRMWhatsappProductFollowupID' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                  <v-hover>
                    <template v-slot="{ isHovering, props: hoverProps }">
                      <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                        <v-tooltip text="Copiar ID del seguimiento de producto al portapapeles" location="top">
                          <template v-slot:activator="{ props: tooltipProps }">
                            <p 
                              v-bind="tooltipProps"
                              @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del seguimiento de producto', 'o', row.item.CRMWhatsappProductFollowupID)"
                              class="hoverableVIcon"
                              style="color: #3F51B5;"
                            >
                              <strong>{{ row.item.CRMWhatsappProductFollowupID }}</strong>
                            </p>
                          </template>
                        </v-tooltip>
                      </template>
                      <template v-else>
                        <p
                          v-bind="hoverProps"
                          @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del seguimiento de producto', 'o', row.item.CRMWhatsappProductFollowupID)"
                          class="hoverableVIcon"
                          style="color: #3F51B5;"
                        >
                          <strong>{{ row.item.CRMWhatsappProductFollowupID }}</strong>
                        </p>
                      </template>
                    </template>
                  </v-hover>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappProductFollowupCRMWhatsappContact' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                  <p>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(row.item) }}</p>
                  <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMWhatsappContactPhoneNumber, false) }}</p>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappProductFollowupCRMLocality' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                  <template v-if="row.item.CRMWhatsappProductFollowupCRMLocalityID == null">
                    <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">No registrada</p>
                  </template>
                  <template v-else>
                    <v-chip
                      :color="row.item.CRMWhatsappProductFollowupCRMLocalityColor || 'primary'"
                      variant="flat"
                      elevation="2"
                      density="compact"
                      label
                    >
                      <p>{{ row.item.CRMWhatsappProductFollowupCRMLocalityName }}</p>
                    </v-chip>
                  </template>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappProductFollowupStatus' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                  <v-chip
                    :color="{'Pendiente (esperando al contacto)': 'error', 'Pendiente (esperando inventario)': 'error', 'Pendiente (otro)': 'error', 'Finalizado': 'success', 'Cancelado': 'warning'}[row.item.CRMWhatsappProductFollowupStatus]"
                    variant="flat"
                    elevation="2"
                    density="compact"
                    label
                  >
                    <p>{{ row.item.CRMWhatsappProductFollowupStatus }}</p>
                  </v-chip>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappProductFollowupStock' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                  <template v-if="row.item.stockCRMWhatsappProductFollowupProductCount == 0">
                    <v-chip color="error" variant="flat" elevation="2" density="compact" label>
                      <p>Sin inventario</p>
                    </v-chip>
                  </template>
                  <template v-else-if="row.item.stockCRMWhatsappProductFollowupProductCount == row.item.totalCRMWhatsappProductFollowupProductCount">
                    <v-chip color="success" variant="flat" elevation="2" density="compact" label>
                      <p>{{ row.item.totalCRMWhatsappProductFollowupProductCount == 1 ? 'El' : `Los ${row.item.totalCRMWhatsappProductFollowupProductCount}`}} producto{{ row.item.totalCRMWhatsappProductFollowupProductCount == 1 ? null : 's' }} tiene{{ row.item.totalCRMWhatsappProductFollowupProductCount == 1 ? null : 'n' }} inventario</p>
                    </v-chip>
                  </template>
                  <template v-else>
                    <v-chip color="warning" variant="flat" elevation="2" density="compact" label>
                      <p>{{ row.item.stockCRMWhatsappProductFollowupProductCount }} de {{ row.item.totalCRMWhatsappProductFollowupProductCount }} producto{{ row.item.stockCRMWhatsappProductFollowupProductCount == 1 ? null : 's' }} tiene{{ row.item.stockCRMWhatsappProductFollowupProductCount == 1 ? null : 'n' }} inventario</p>
                    </v-chip>
                  </template>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappProductFollowupNote' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                  <template v-if="row.item.CRMWhatsappProductFollowupNote == null || !/\S/.test(row.item.CRMWhatsappProductFollowupNote)">
                    <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">Sin nota</p>
                  </template>
                  <template v-else>
                    <p style="width: 400px; max-height: 150px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;">{{ row.item.CRMWhatsappProductFollowupNote }}</p>
                  </template>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappProductFollowupCreationCRMAgent' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                  <v-chip
                    :color="row.item.CRMWhatsappProductFollowupCreationCRMAgentColor || 'primary'"
                    variant="flat"
                    elevation="2"
                    label
                  >
                    <div style="display: flex; align-items: center;">
                      <img
                        :src="row.item.CRMWhatsappProductFollowupCreationCRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : row.item.CRMWhatsappProductFollowupCreationCRMAgentProfilePictureURL"
                        :draggable="false"
                        style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                      >
                      <div style="display: flex; flex-direction: column;">
                        <p>{{ row.item.CRMWhatsappProductFollowupCreationCRMAgentName == null ? 'No registrado' : row.item.CRMWhatsappProductFollowupCreationCRMAgentName }}</p>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon size="x-small">mdi-clock</v-icon>
                          <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappProductFollowupCreationDatetime) }}</p>
                        </div>
                      </div>
                    </div>
                  </v-chip>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappProductFollowupUpdateCRMAgent' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                  <template v-if="row.item.CRMWhatsappProductFollowupUpdateCRMAgentID == null">
                    <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">No actualizado</p>
                  </template>
                  <template v-else>
                    <v-chip
                      :color="row.item.CRMWhatsappProductFollowupUpdateCRMAgentColor || 'primary'"
                      variant="flat"
                      elevation="2"
                      label
                    >
                      <div style="display: flex; align-items: center;">
                        <img
                          :src="row.item.CRMWhatsappProductFollowupUpdateCRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : row.item.CRMWhatsappProductFollowupUpdateCRMAgentProfilePictureURL"
                          :draggable="false"
                          style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                        >
                        <div style="display: flex; flex-direction: column;">
                          <p>{{ row.item.CRMWhatsappProductFollowupUpdateCRMAgentName == null ? 'No registrado' : row.item.CRMWhatsappProductFollowupUpdateCRMAgentName }}</p>
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon size="x-small">mdi-clock</v-icon>
                            <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappProductFollowupUpdateDatetime) }}</p>
                          </div>
                        </div>
                      </div>
                    </v-chip>
                  </template>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappProductFollowupCompletionCRMAgent' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                  <template v-if="row.item.CRMWhatsappProductFollowupCompletionCRMAgentID == null">
                    <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">No finalizado</p>
                  </template>
                  <template v-else>
                    <v-chip
                      :color="row.item.CRMWhatsappProductFollowupCompletionCRMAgentColor || 'primary'"
                      variant="flat"
                      elevation="2"
                      label
                    >
                      <div style="display: flex; align-items: center;">
                        <img
                          :src="row.item.CRMWhatsappProductFollowupCompletionCRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : row.item.CRMWhatsappProductFollowupCompletionCRMAgentProfilePictureURL"
                          :draggable="false"
                          style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                        >
                        <div style="display: flex; flex-direction: column;">
                          <p>{{ row.item.CRMWhatsappProductFollowupCompletionCRMAgentName == null ? 'No registrado' : row.item.CRMWhatsappProductFollowupCompletionCRMAgentName }}</p>
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon size="x-small">mdi-clock</v-icon>
                            <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappProductFollowupCompletionDatetime) }}</p>
                          </div>
                        </div>
                      </div>
                    </v-chip>
                  </template>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappProductFollowupActions' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                  <v-menu
                    @update:model-value="navigation.contextMenuItem = null"
                    @contextmenu.prevent="null"
                    transition="scroll-y-transition"
                    scrim="black"
                    opacity="0.8"
                    style="user-select: none; cursor: default;"
                  >
                    <template v-slot:activator="{ props }">
                      <v-btn
                        v-bind="props"
                        @click="navigation.contextMenuItem = {'type': 'CRMWhatsappProductFollowup', ...row.item}"
                        color="indigo"
                        density="compact"
                        class="hoverableVButton"
                      >
                        <v-icon start>mdi-dots-vertical</v-icon>
                        <p style="font-size: small;">ACCIONES</p>
                      </v-btn>
                    </template>
                    <v-list density="compact" style="overflow-x: hidden; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;">
                      <v-list-item
                        @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del seguimiento de producto', 'o', row.item.CRMWhatsappProductFollowupID);" 
                        title="Copiar ID del seguimiento de producto" 
                        class="hoverableVListItem" 
                      >
                        <template v-slot:prepend>
                          <v-icon color="indigo">mdi-source-branch-sync</v-icon>
                          <v-icon color="indigo" size="x-small">mdi-barcode</v-icon>
                        </template>
                      </v-list-item>
                      <v-list-item
                        @click="$root.dialogComponent.openCRMWhatsappProductFollowupDialog('select', null, row.item.CRMWhatsappProductFollowupID, null, null)"
                        title="Ver seguimiento de producto"
                        class="hoverableVListItem"
                      >
                        <template v-slot:prepend>
                          <v-icon color="indigo">mdi-source-branch-sync</v-icon>
                          <v-icon color="indigo" size="small">mdi-open-in-app</v-icon>
                        </template>
                      </v-list-item>
                      <v-list-item
                        @click="$root.dialogComponent.openCRMWhatsappProductFollowupDialog('update', null, row.item.CRMWhatsappProductFollowupID, null, (() => this.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog(true)))"
                        title="Actualizar seguimiento de producto"
                        class="hoverableVListItem"
                      >
                        <template v-slot:prepend>
                          <v-icon color="indigo">mdi-source-branch-sync</v-icon>
                          <v-icon color="indigo" size="small">mdi-pencil</v-icon>
                        </template>
                      </v-list-item>
                      <v-list-item
                        @click="$root.dialogComponent.openCRMWhatsappProductFollowupDialog('delete', null, row.item.CRMWhatsappProductFollowupID, null, (() => this.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog(true)))"
                        title="Eliminar seguimiento de producto"
                        class="hoverableVListItem"
                      >
                        <template v-slot:prepend>
                          <v-icon color="indigo">mdi-source-branch-sync</v-icon>
                          <v-icon color="indigo" size="small">mdi-delete</v-icon>
                        </template>
                      </v-list-item>
                      <v-list-item
                        @click="$root.dialogComponent.openSendCRMWhatsappMessageToCRMWhatsappContactDialog(row.item.CRMWhatsappContactID, false)"
                        title="Iniciar conversación"
                        class="hoverableVListItem"
                      >
                        <template v-slot:prepend>
                          <v-icon color="indigo">mdi-chat-plus</v-icon>
                        </template>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </td>
            </template>
          </tr>
        </template>
        <template v-slot:bottom></template>
      </v-data-table>
    </template>
    <v-card elevation="0" rounded="0" color="indigo" style="flex-shrink: 0; height: 2px;"></v-card>
    <v-card color="primary" elevation="0" rounded="0" class="footerContainer">
      <div class="threeColumnContainer">
        <v-autocomplete
          ref="CRMWhatsappProductFollowupCreationCRMAgentID"
          v-model="input.CRMWhatsappProductFollowupCreationCRMAgentID"
          @update:model-value="display.CRMWhatsappProductFollowup = null; navigation.noData = false;"
          :items="computed_CRMAgents"
          :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView || loader.pagination"
          :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView || loader.pagination"
          label="Filtrar por agente de creación del seguimiento"
          prepend-inner-icon="mdi-account-plus"
          clear-icon="mdi-backspace"
          variant="outlined"
          density="compact" 
          autocomplete="off"
          item-title="CRMAgentName"
          item-value="CRMAgentID"
          multiple
          chips
          closable-chips
          clearable
          hide-no-data
          hide-details
        >
          <template v-slot:chip="{ item, index }">
            <template v-if="index < 3">
              <v-chip 
                :color="item.raw.CRMAgentColor || 'primary'"
                elevation="2"
                variant="flat"
                label
              >
                <div style="display: flex; align-items: center;">
                  <img
                    :src="item.raw.CRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : item.raw.CRMAgentProfilePictureURL"
                    :draggable="false"
                    style="width: 25px; height: 25px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                  >
                  <p>{{ item.raw.CRMAgentName }}</p>
                </div>
                <template v-slot:close>
                  <v-icon 
                    @click="input.CRMWhatsappProductFollowupCreationCRMAgentID = input.CRMWhatsappProductFollowupCreationCRMAgentID.filter(CRMAgentID => CRMAgentID != item.raw.CRMAgentID); display.CRMWhatsappProductFollowup = null; navigation.noData = false;"
                    class="hoverableVIcon"
                  >
                    mdi-close-circle
                  </v-icon>
                </template>
              </v-chip>
            </template>
            <template v-else-if="index == 3">
              <p style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappProductFollowupCreationCRMAgentID.length - 3 }} agente{{ input.CRMWhatsappProductFollowupCreationCRMAgentID.length - 3 == 1 ? '' : 's' }})</p>
            </template>
          </template>
          <template v-slot:item="{ item, index }">
            <template v-if="index == 0 && computed_CRMAgents.length > 1">
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.allCRMWhatsappProductFollowupCreationCRMAgentIDSelected = !input.allCRMWhatsappProductFollowupCreationCRMAgentIDSelected; input.CRMWhatsappProductFollowupCreationCRMAgentID = input.allCRMWhatsappProductFollowupCreationCRMAgentIDSelected ? computed_CRMAgents.map(CRMAgent => CRMAgent.CRMAgentID) : []; display.CRMWhatsappProductFollowup = null; navigation.noData = false;"
                  :title="null" 
                  :subtitle="null"
                  :active="input.allCRMWhatsappProductFollowupCreationCRMAgentIDSelected"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-switch 
                      :model-value="input.allCRMWhatsappProductFollowupCreationCRMAgentIDSelected"
                      density="compact"
                      color="indigo"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 20px;"
                    ></v-switch>
                  </template>
                  <p>{{ input.allCRMWhatsappProductFollowupCreationCRMAgentIDSelected ? 'Deseleccionar todos los agentes' : (input.CRMWhatsappProductFollowupCreationCRMAgentID.length == 0 ? 'Seleccionar todos los agentes' : `Seleccionar ${computed_CRMAgents.length - input.CRMWhatsappProductFollowupCreationCRMAgentID.length == 1 ? 'el' : 'los'} ${computed_CRMAgents.length - input.CRMWhatsappProductFollowupCreationCRMAgentID.length > 1 ? computed_CRMAgents.length - input.CRMWhatsappProductFollowupCreationCRMAgentID.length : ''} agente${computed_CRMAgents.length - input.CRMWhatsappProductFollowupCreationCRMAgentID.length == 1 ? '' : 's'} restante${computed_CRMAgents.length - input.CRMWhatsappProductFollowupCreationCRMAgentID.length == 1 ? '' : 's'}`)}}</p>
                </v-list-item>
              </v-list>
            </template>
            <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
              <v-list-item 
                @click="(input.CRMWhatsappProductFollowupCreationCRMAgentID.includes(item.raw.CRMAgentID) ? input.CRMWhatsappProductFollowupCreationCRMAgentID = input.CRMWhatsappProductFollowupCreationCRMAgentID.filter(CRMAgentID => CRMAgentID != item.raw.CRMAgentID) : input.CRMWhatsappProductFollowupCreationCRMAgentID.push(item.raw.CRMAgentID)); input.allCRMWhatsappProductFollowupCreationCRMAgentIDSelected = input.CRMWhatsappProductFollowupCreationCRMAgentID.length == computed_CRMAgents.length; display.CRMWhatsappProductFollowup = null; navigation.noData = false;"
                :title="null" 
                :subtitle="null"
                :active="input.CRMWhatsappProductFollowupCreationCRMAgentID.includes(item.raw.CRMAgentID)"
                class="hoverableVListItem"
              >
                <template v-slot:prepend>
                  <v-checkbox-btn 
                    :model-value="input.CRMWhatsappProductFollowupCreationCRMAgentID.includes(item.raw.CRMAgentID)"
                    density="compact"
                    readonly
                    hide-details
                    class="hoverableVIcon"
                    style="margin-right: 10px;"
                  ></v-checkbox-btn>
                </template>
                <v-chip
                  :color="item.raw.CRMAgentColor || 'primary'"
                  density="compact"
                  variant="flat"
                  elevation="2"
                  label
                  style="margin-top: 5px; margin-bottom: 5px;"
                >
                  <div style="display: flex; align-items: center;">
                    <img
                      :src="item.raw.CRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : item.raw.CRMAgentProfilePictureURL"
                      :draggable="false"
                      style="width: 25px; height: 25px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                    >
                    <p>{{ item.raw.CRMAgentName }}</p>
                  </div>
                </v-chip>
              </v-list-item>
            </v-list>
          </template>
        </v-autocomplete>
        <v-text-field
          v-model="input.CRMWhatsappProductFollowupSearchQuery"
          @update:model-value="display.CRMWhatsappProductFollowup = null; navigation.noData = false;"
          :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView || loader.pagination"
          :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView || loader.pagination"
          label="Búsqueda rápida"
          prepend-inner-icon="mdi-magnify"
          clear-icon="mdi-backspace"
          variant="outlined"
          density="compact" 
          autocomplete="off"
          clearable
          hide-details
        ></v-text-field>
        <v-btn
          @click="selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView(true)" 
          :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView || loader.pagination" 
          color="indigo"
          block 
          class="hoverableVButton"
        >
          <v-icon start>mdi-magnify</v-icon>
          <p style="font-size: small;">BUSCAR</p>
        </v-btn>
      </div>
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
        <template v-if="computed_CRMWhatsappProductFollowup.length > 0">
          <v-pagination
            v-model="navigation.CRMWhatsappProductFollowupPage"
            @update:model-value="selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView(false)"
            :length="Math.ceil(computed_CRMWhatsappProductFollowupCount / navigation.CRMWhatsappProductFollowupLimit)"
            :disabled="loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView || loader.pagination"
            :total-visible="5"
            density="compact"
            size="small"
          ></v-pagination>
          <p style="font-size: x-small;">{{ (computed_CRMWhatsappProductFollowupCount == 0) ? '0 de 0 seguimientos' : `${(navigation.CRMWhatsappProductFollowupPage - 1) * navigation.CRMWhatsappProductFollowupLimit + 1} - ${Math.min(navigation.CRMWhatsappProductFollowupPage * navigation.CRMWhatsappProductFollowupLimit, computed_CRMWhatsappProductFollowupCount)} de ${computed_CRMWhatsappProductFollowupCount} seguimientos`}}</p>
        </template>
      </div>
    </v-card>
  </div>
</template>

<style scoped>
  .twoColumnContainer {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .footerContainer {
    display: grid;
    grid-template-columns: 0.9fr 0.1fr;
    align-items: center;
    gap: 15px;
    padding: 15px;
    flex-shrink: 0;
  }
  .threeColumnContainer {
    display: grid;
    align-items: center;
    grid-template-columns: 0.55fr 0.35fr 0.1fr;
    gap: 15px;
  }
  @media (max-width: 1200px) {
    .twoColumnContainer {
      flex-direction: column;
    }
    .footerContainer {
      grid-template-columns: 1fr;
    }
    .threeColumnContainer {
      grid-template-columns: 1fr;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import AppLoaderScreen from '@/components/AppLoaderScreen.vue';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: 
    {
      AppLoaderScreen
    },
    data: () => ({
      input: 
      {
        allCRMWhatsappProductFollowupCreationCRMAgentIDSelected: false,
        CRMWhatsappProductFollowupCreationCRMAgentID: [],
        CRMWhatsappProductFollowupSearchQuery: null
      },
      display: 
      {
        CRMWhatsappProductFollowupHeaders: [],
        CRMWhatsappProductFollowup: null
      },
      navigation: 
      {
        noData: false,
        contextMenuIsVisible: false,
        contextMenuItem: null,
        contextMenuX: 0,
        contextMenuY: 0,
        CRMWhatsappProductFollowupPage: 1,
        CRMWhatsappProductFollowupLimit: 100
      },
      loader: 
      {
        startup: false,
        selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView: false,
        pagination: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMAgents: null,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    computed: 
    {
      computed_CRMWhatsappProductFollowupHeaders(){
        return this.display.CRMWhatsappProductFollowupHeaders.slice().sort((CRMWhatsappProductFollowupHeaderA, CRMWhatsappProductFollowupHeaderB) => CRMWhatsappProductFollowupHeaderA.index - CRMWhatsappProductFollowupHeaderB.index);
      },
      computed_CRMWhatsappProductFollowup(){
        return this.display.CRMWhatsappProductFollowup == null ? [] : this.display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowup;
      },
      computed_CRMWhatsappProductFollowupCount(){
        return this.display.CRMWhatsappProductFollowup == null ? 0 : this.display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCount;
      },
      computed_CRMAgents(){
        if (this.systemInformationData.CRMAgents == null) return [];
        else return this.systemInformationData.CRMAgents;
      }
    },

    methods: 
    {
      async selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView(isNewSearch){
        if (isNewSearch){
          this.navigation.CRMWhatsappProductFollowupPage = 1;
          this.loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView = true;
        }
        this.loader.pagination = true;
        const selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsViewRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappProductFollowupCreationCRMAgentID': this.input.CRMWhatsappProductFollowupCreationCRMAgentID,
          'CRMWhatsappProductFollowupSearchQuery': this.input.CRMWhatsappProductFollowupSearchQuery,
          'page': this.navigation.CRMWhatsappProductFollowupPage,
          'limit': this.navigation.CRMWhatsappProductFollowupLimit
        };
        const selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFollowup/functions/selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView', selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsViewRequestQuery);
        if (selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsViewResult.success){
          this.display.CRMWhatsappProductFollowup = selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsViewResult.result;
          this.navigation.noData = this.display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCount == 0;
        }
        else this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView_error', 'error', 'Ha ocurrido un error inesperado al consultar los seguimientos de producto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        this.loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView = false;
        this.loader.pagination = false;
      },

      updateTableHeaderIndex(tableName, headerValue, headerIndexChange){
        const updatedTableHeader = this.display[`${tableName}Headers`].find(header => header.value == headerValue);
        const swappedTableHeader = this.display[`${tableName}Headers`].find(header => header.index == (this.display[`${tableName}Headers`].find(header => header.value == headerValue).index + headerIndexChange));
        if (updatedTableHeader && swappedTableHeader) [updatedTableHeader.index, swappedTableHeader.index] = [swappedTableHeader.index, updatedTableHeader.index];
        localStorage.setItem(`CRMWhatsappProductFollowupsView_${tableName}Headers`, JSON.stringify(this.display[`${tableName}Headers`]));      
      },
      updateTableVisibility(tableName){
        localStorage.setItem(`CRMWhatsappProductFollowupsView_${tableName}Headers`, JSON.stringify(this.display[`${tableName}Headers`]));      
      },
      getTableRowClass(tableName, item){
        if (tableName == 'CRMWhatsappProductFollowup'){
          if (this.loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView || item.loader) return 'loadingVDataTableRow';
          if (this.navigation.contextMenuItem != null) {
            if (this.navigation.contextMenuItem.CRMWhatsappProductFollowupID == item.CRMWhatsappProductFollowupID) return 'selectedVDataTableRow';
            else return 'bluredVDataTableRow';
          }
          if (item.stockCRMWhatsappProductFollowupProductCount == item.totalCRMWhatsappProductFollowupProductCount) return 'successVDataTableRow';
        }
        return null;
      },
      async prepareTables(){
        const CRMWhatsappProductFollowupHeaders = 
        [
          {title: 'ID', value: 'CRMWhatsappProductFollowupID', icon: 'mdi-barcode', visible: true},
          {title: 'CONTACTO', value: 'CRMWhatsappProductFollowupCRMWhatsappContact', icon: 'mdi-account', visible: true},
          {title: 'LOCALIDAD', value: 'CRMWhatsappProductFollowupCRMLocality', icon: 'mdi-store', visible: true},
          {title: 'ESTADO', value: 'CRMWhatsappProductFollowupStatus', icon: 'mdi-source-branch', visible: true},
          {title: 'INVENTARIO', value: 'CRMWhatsappProductFollowupStock', icon: 'mdi-package', visible: true},
          {title: 'NOTA', value: 'CRMWhatsappProductFollowupNote', icon: 'mdi-text-box', visible: true},
          {title: 'CREACIÓN', value: 'CRMWhatsappProductFollowupCreationCRMAgent', icon: 'mdi-account-plus', visible: true},
          {title: 'ACTUALIZACIÓN', value: 'CRMWhatsappProductFollowupUpdateCRMAgent', icon: 'mdi-account-edit', visible: true},
          {title: 'FINALIZACIÓN', value: 'CRMWhatsappProductFollowupCompletionCRMAgent', icon: 'mdi-account-check', visible: true},
          {title: 'ACCIONES', value: 'CRMWhatsappProductFollowupActions', icon: 'mdi-dots-vertical', visible: true}
        ].map((header, index) => ({ ...header, index: index }));
        let localStorageHeaders = JSON.parse(localStorage.getItem('CRMWhatsappProductFollowupsView_CRMWhatsappProductFollowupHeaders') || JSON.stringify(CRMWhatsappProductFollowupHeaders));
        for (const localStorageHeader of localStorageHeaders){
          const CRMWhatsappProductFollowupHeader = CRMWhatsappProductFollowupHeaders.find(CRMWhatsappProductFollowupHeader => CRMWhatsappProductFollowupHeader.value == localStorageHeader.value);
          if (CRMWhatsappProductFollowupHeader){
            if (localStorageHeader.visible != null) CRMWhatsappProductFollowupHeader.visible = localStorageHeader.visible;
            if (localStorageHeader.index != null) CRMWhatsappProductFollowupHeader.index = localStorageHeader.index;
          }
        }
        this.display.CRMWhatsappProductFollowupHeaders = CRMWhatsappProductFollowupHeaders.slice().sort((CRMWhatsappProductFollowupHeaderA, CRMWhatsappProductFollowupHeaderB) => CRMWhatsappProductFollowupHeaderA.index - CRMWhatsappProductFollowupHeaderB.index);
      },
      async getSystemInformation(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){ 
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
            this.input.CRMWhatsappProductFollowupCreationCRMAgentID = [this.systemInformationData.CRMAgent.CRMAgentID];
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al consultar la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al consultar la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
    },

    async mounted() {
      this.loader.startup = true;
      await this.getSystemInformation();
      await this.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupsView(true);
      await this.prepareTables();
      this.$generalFunctions.default.focusInput(this, 'CRMWhatsappProductFollowupCreationCRMAgentID');
      this.loader.startup = false;
    },

    beforeUnmount(){
      if (this.systemInformationData.updateSubscription) {
        systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
        this.systemInformationData.updateSubscription = null;
      }
    }
  }
</script>